import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiAllSeriesData = () => {
    const { allStrapiSerie } = useStaticQuery(graphql`
        query {
            allStrapiSerie {
                nodes {
                    title
                    card_title
                    slug
                  }
              } 
          }
      `)
    return { allStrapiSerie }
}
